/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSportsFootballIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sports-football"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.53 21.75Q7.03 21.88 5.4 21.61Q3.77 21.35 3.1 20.93Q2.63 20.02 2.38 18.48Q2.13 16.93 2.25 15.45ZM11.75 21.27L2.67 12.18Q3.13 10.18 3.95 8.59Q4.78 7 5.92 5.88Q6.97 4.8 8.53 4Q10.07 3.2 12.18 2.67L21.3 11.8Q20.8 13.82 20 15.38Q19.2 16.93 18.07 18.05Q16.9 19.23 15.31 20.04Q13.72 20.85 11.75 21.27ZM10.13 15.72L15.75 10.1Q16.13 9.72 16.13 9.18Q16.13 8.63 15.75 8.25Q15.38 7.88 14.82 7.88Q14.28 7.88 13.9 8.25L8.28 13.88Q7.9 14.25 7.9 14.8Q7.9 15.35 8.28 15.72Q8.65 16.1 9.2 16.1Q9.75 16.1 10.13 15.72ZM21.77 8.6L15.5 2.23Q16.85 2.1 18.5 2.35Q20.15 2.6 20.98 3.08Q21.43 3.95 21.66 5.64Q21.9 7.33 21.77 8.6Z" fill={color} />
    </svg>
  );
}
